export const CLEAN_ENERGY_AWARD_ELIGIBLE_IDS = [
  'solar-pv',
  'concentrated-solar',
  'onshore-wind',
  'offshore-wind',
  'tidal',
  'wave-power',
  'run-of-river-hydro',
  'geothermal',
  'small-modular-nuclear',
  'large-nuclear'
];

export const CLEAN_ENERGY_AWARD_ELIGIBLE_SET = new Set(
  CLEAN_ENERGY_AWARD_ELIGIBLE_IDS
);

export const CLEAN_ENERGY_AWARD_TIERS = [
  {
    minCleanShare: 0.95,
    minVariableCleanShare: 0.5,
    bonus: 8,
    label: 'Renewable-led transition'
  },
  {
    minCleanShare: 0.8,
    minVariableCleanShare: 0.35,
    bonus: 5,
    label: 'Renewable transition'
  },
  {
    minCleanShare: 0.8,
    minVariableCleanShare: 0,
    bonus: 3,
    label: 'Clean system'
  }
];

export const RESILIENCE_AWARD_TIERS = [
  {
    minFamilies: 6,
    maxLargestFamilyShareExclusive: 0.45,
    bonus: 10,
    label: 'Highly resilient system'
  },
  {
    minFamilies: 5,
    maxLargestFamilyShareExclusive: 0.55,
    bonus: 5,
    label: 'Diversified system'
  },
  {
    minFamilies: 4,
    maxLargestFamilyShareExclusive: 0.75,
    bonus: 3,
    label: 'Basic diversity'
  }
];
